import React , { createContext, useState } from 'react'

export const BackIndex = createContext() ;
export const BackIndexProvider = ( {children} ) => {
    const [Index , setIndex] = useState(1)
    const [IndexNav , setIndexNav] = useState("/Super")
  return (
    <BackIndex.Provider value={ {index : Index , setIndex : setIndex ,indexNav :IndexNav ,setIndexNav : setIndexNav }}>
        {children}
    </BackIndex.Provider >
  )
}